





































import Enumerable from "linq";
import { Component, Mixins, Emit } from "vue-property-decorator";
import { DateEditableMixin } from "./mixins";
import ComboBoxSelector from "./ComboBoxSelector.vue";

@Component({
  components: {
    ComboBoxSelector,
  }
})
export default class DateEditor extends Mixins(DateEditableMixin) {
  @Emit()
  onYearFocused(): void {}

  $refs!: {
    yearSelector: ComboBoxSelector;
  };

  get months(): number[] {
    return Enumerable.rangeTo(1, 12).toArray();
  }

  get days(): number[] {
    return Enumerable.rangeTo(1, new Date(this.year, this.month, 0).getDate())
      .toArray();
  }

  get startYear(): number {
    return this.year - this.$configuration.system.date.years.count.past;
  }

  get endYear(): number {
    return this.year + this.$configuration.system.date.years.count.future;
  }

  get years(): number[] {
    return Enumerable.rangeTo(this.endYear, this.startYear)
      .where(y => y > 0)
      .toArray();
  }

  setYearSelectorFocus(): void {
    if (this.$refs.yearSelector) {
      this.$refs.yearSelector.selectAllInputText();
    }
  }

  onYearFocus() {
    this.onYearFocused();
  }
}
